import { listItem } from './listItem';
export var bulletList = function bulletList(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  var result = [];
  node.forEach(function (item) {
    result.push(listItem(item, '*', context));
  });
  return result.join('\n');
};